import { render, staticRenderFns } from "./appoint.vue?vue&type=template&id=4134bb46&scoped=true"
import script from "./appoint.vue?vue&type=script&lang=js"
export * from "./appoint.vue?vue&type=script&lang=js"
import style0 from "./appoint.vue?vue&type=style&index=0&id=4134bb46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4134bb46",
  null
  
)

export default component.exports